import styled from 'styled-components';

export const ResetButton = styled.button`
  display: inline-flex;
  align-items: center;
  min-height: 48px;
  margin: 8px 0 16px;
  padding: 12px 20px;
  border: 0;
  border-radius: 9999px;
  background: none;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  line-height: 1.4;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.defaultColors.lighterGrey};
  }
`;
